import { N9_GROUP_URL, N9_GROUP_LABEL, N9_SYSTEM_URL } from './n9-attribution.js';
import './n9-attribution.css';

export function N9Attribution({ showLogos = false }) {
  return <span className={`n9-attribution${showLogos ? ' n9-attribution--logos' : ''}`}>
    <span>من برامج</span>{' '}
    <a href={N9_SYSTEM_URL} title="الموقع الرسمي لـ N9 LAW SYSTEM">
      {showLogos && <img src="/assets/n9-logo.png" alt="" width="18" height="18"/>}
      <bdi>N9 LAW SYSTEM</bdi>
    </a>
    <span aria-hidden="true"> · </span>
    <a href={N9_GROUP_URL} title="لمزيد من التفاصيل عن N9 GROUP">
      {showLogos && <img src="/assets/n9-group-logo.png" alt="" width="18" height="18"/>}
      <bdi>{N9_GROUP_LABEL}</bdi>
    </a>
  </span>;
}
